import React from 'react'
import { Grid, Box } from '@material-ui/core'
import { useFormikContext } from 'formik'
import TextField from 'presentation/shared/components/TextField'

import { EmergencyRoomEditFormikValues } from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import { defaultGridProps } from '../Constants'
import Heading from 'presentation/shared/components/Heading'
import { getAge } from 'presentation/utils/get-age'
import { cpfMask, dateMask, phoneMask } from 'presentation/utils/masks'
import SelectField from 'presentation/shared/components/SelectField'
import { maritalStatus } from 'presentation/utils/default-marital-status'
import { gender } from 'common/enum/gender'
import { ReligionModel } from 'domain/entities/religion-model'

type PatientDetailsProps = {
  religions: ReligionModel[]
}

export function PatientDetails({ religions }: PatientDetailsProps) {
  const { values, handleChange, errors, setValues } =
    useFormikContext<EmergencyRoomEditFormikValues>()

  const defaultTextFieldProps = {
    placeholder: values.isEditing ? 'Digite aqui...' : '-',
    disabled: !values.isEditing,
    autoComplete: 'off'
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box mb={1} overflow="hidden">
          <Heading color="primary">DADOS DO PACIENTE</Heading>
        </Box>
      </Grid>
      <Grid item xs={12} container spacing={4}>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.name'}
            onChange={handleChange}
            value={values?.updatePatient?.name || ''}
            label="Nome:"
            error={errors?.updatePatient?.name}
            required
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.socialName'}
            onChange={handleChange}
            value={values?.updatePatient?.socialName || ''}
            label="Nome social:"
            error={errors?.updatePatient?.socialName}
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <SelectField
            {...defaultTextFieldProps}
            label="Sexo"
            name={'updatePatient.gender'}
            id="gender"
            value={values?.updatePatient?.gender || ''}
            onChange={handleChange}
            items={gender}
            error={errors?.updatePatient?.gender}
            required
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            onChange={handleChange}
            value={getAge(values?.updatePatient?.birthday || '') || ''}
            label="Idade"
            disabled
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.birthday'}
            onChange={handleChange}
            value={values?.updatePatient?.birthday || ''}
            placeholder="__/__/____"
            label="Data de nascimento"
            mask={dateMask}
            error={errors?.updatePatient?.birthday}
            required
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.rg'}
            onChange={handleChange}
            value={values?.updatePatient?.rg || ''}
            label="RG:"
            error={errors?.updatePatient?.rg}
            maxLength={30}
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.cpf'}
            onChange={handleChange}
            value={values?.updatePatient?.cpf || ''}
            label="CPF:"
            mask={cpfMask}
            disabled
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.email'}
            onChange={handleChange}
            value={values?.updatePatient?.email || ''}
            label="Email:"
            error={errors?.updatePatient?.email}
            required
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.phone'}
            onChange={handleChange}
            value={values?.updatePatient?.phone || ''}
            placeholder="(--) Digite aqui..."
            mask={phoneMask}
            label="Celular"
            error={errors?.updatePatient?.phone}
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <SelectField
            {...defaultTextFieldProps}
            label="Estado civil"
            name={'updatePatient.maritalStatus'}
            id="maritalStatus"
            value={values?.updatePatient?.maritalStatus || ''}
            onChange={handleChange}
            items={maritalStatus}
            error={errors?.updatePatient?.maritalStatus}
            required
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <TextField
            {...defaultTextFieldProps}
            name={'updatePatient.company'}
            onChange={handleChange}
            value={values?.updatePatient?.company || ''}
            label="Empresa:"
            error={errors?.updatePatient?.company}
          />
        </Grid>
        <Grid item {...defaultGridProps}>
          <SelectField
            {...defaultTextFieldProps}
            label="Religião"
            name={'updatePatient.religion_id'}
            id="religion"
            value={values?.updatePatient?.religion_id || ''}
            onChange={(e) => {
              const religion = religions.find(
                (religion) => String(religion.religion_id) === e.target.value
              )
              if (!religion) return
              setValues({
                ...values,
                updatePatient: {
                  ...values.updatePatient,
                  religion_id: religion.religion_id,
                  religion: religion.name
                }
              })
            }}
            items={religions.map(({ name, religion_id }) => ({
              label: name,
              value: religion_id
            }))}
            error={errors?.updatePatient?.religion_id}
            required
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
